import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestService } from '../shared/services/request-service';
import { DocumentService } from './document.service';
import { ReportRequest } from '../shared/data-filter/report-filter/report-filter.model';
import { Observable } from 'rxjs';
import { PriceSheetClient } from '../shared/dto/price-sheet';
import { tap } from 'rxjs/operators';

@Injectable()
export class ReportService {

  constructor(private httpClient: HttpClient,
              private requestService: RequestService,
              private docService: DocumentService) {
  }

  public generateReport(reportRequest: ReportRequest): void  {
    const url = '/api/report/generate';
    const headers = this.requestService.buildHttpHeaders();

    this.httpClient.post(url, reportRequest, {
      headers: headers,
      observe: 'response',
      responseType: 'blob'
    })
      .toPromise()
      .then(resp => {
        this.docService.saveFile(resp);
      }
      );
  }

  public generatePriceSheetComparison(type: string, priceSheetIds: number[]): Observable<any> {
    const url = `/api/price-sheet-comparison?type=${type}`;
    const headers = this.requestService.buildHttpHeaders();

    return this.httpClient.post(url, priceSheetIds, {
      headers: headers,
      observe: 'response',
      responseType: 'blob'
    })
      .pipe(
        tap((resp) => {
          this.docService.saveFile(resp);
        })
      );
  }

  public getPriceSheetClientUsage(id: number, type: string): Observable<PriceSheetClient> {
    const url = `/api/price-sheet-clients/${id}?type=${type}`;
    const headers = this.requestService.buildHttpHeaders();

    return this.httpClient.get<PriceSheetClient>(url, { headers: headers });
  }
}
